<template>
      <div></div>
</template>

<script>

    export default {

        data: function() {
            return  {
                formcompleted: false,
                formdata:{
                    'your':
                    {
                        title: this.trans.application.titel_ihre_angaben[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'your-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-firstname',
                                name: 'Vorname',
                                value: '',
                                label: this.trans.application.vorname[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-email',
                                name: 'E-Mail',
                                value: '',
                                label: this.trans.application.mail[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'your-phone',
                                name: 'Telefon',
                                value: '',
                                label: this.trans.application.telefon[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            }
                        ]
                    },
                    'child':
                    {
                        title: this.trans.application.titel_angaben_kind[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'child-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-firstname',
                                name: 'Vorname',
                                value: '',
                                label: this.trans.application.vorname[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-birthday',
                                name: 'Geburtsdatum',
                                value: '',
                                label: this.trans.application.geburtsdatum[this.lang],
                                type: 'date',
                                mode: 'age',
                                validation: ['required'],
                                placeholder: false
                            },
                             {
                                id: 'child-class',
                                name: 'Klasse',
                                value: '',
                                label: this.trans.application.klasse[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },

                        ]
                    },
                    'general-policy':
                    {
                        title: "",
                        status: 0,
                        type: 'fix',
                        fields:[
                            {
                                id: 'general-policy',
                                name: 'Mit dieser Anmeldung bin ich mit den Datenschutzrichtlinien von der Lakeside School einverstanden.',
                                value: '',
                                label: this.trans.application.agree[this.lang],
                                type: 'checkbox',
                                selection:[ this.trans.application.ja[this.lang]],
                                validation: ['required']
                            },

                         ]
                    }

                }
            }
        },
        props: {

             lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },

        },


    }
</script>
